import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import {
  formatTipoAcomodacao,
  tipoAcomodacaoOptions,
} from "./tipo_acomodacao";

const TipoAcomodacaoFormatter = ({ value }) => (
  <TextField
    value={formatTipoAcomodacao(value)}
    InputProps={{ disableUnderline: true }}
  />
);

const TipoAcomodacaoEditor = ({ value, onValueChange }) => (
  <Select
    input={<Input />}
    value={value}
    onChange={(event) => onValueChange(event.target.value)}
    style={{ width: "100%" }}
  >
    <MenuItem value="">Todos</MenuItem>
    {tipoAcomodacaoOptions().map((opt) => (
      <MenuItem key={opt.id} value={opt.id}>
        {opt.label}
      </MenuItem>
    ))}
  </Select>
);

export const TipoAcomodacaoTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={TipoAcomodacaoFormatter}
    editorComponent={TipoAcomodacaoEditor}
    {...props}
  />
);
